<template>
    <m-layout>
      <div fill-height class="fill-height" style="max-width:100%; position:relative">
        <v-dialog v-model="dialog_view" width="400px">
          <img :src="imageUrl" width="400px"/>
        </v-dialog>
        <v-card-title class="m-page__title">
          <span class="headline">Inserts</span>
          <v-btn icon class="mx-0" @click="onRefresh">
             <v-icon color="primary">refresh</v-icon>
          </v-btn>
        </v-card-title>

        <m-inserts-edit :form="form" :expense="selectedItem" :dialog="dialog_edit" @update="onUpdate" @close="onClose"></m-inserts-edit>
        <m-inserts-form :form="form" :dialog="dialog" @save="onSave" @close="onClose"></m-inserts-form>

        <v-card style="max-width:100%; position:relative">
          <v-card-title>
            <v-btn v-if="can('invoicing')"
              absolute
              dark
              fab
              top
              right
              color="primary"
              @click.native.stop="dialog = true">
              <v-icon>add</v-icon>
            </v-btn>

            <v-text-field
              append-icon="search"
              label="Search"
              single-line
              hide-details
              v-model="search"
            ></v-text-field>
          <v-spacer></v-spacer>
          <m-csv-btn :disabled="items.length === 0" :data="csvItems" filename="inserts.csv" separator-excel></m-csv-btn>
          </v-card-title>
          <v-data-table
              v-bind:headers="headers"
              v-bind:items="items"
              v-bind:search="search"
              :footer-props="{ 'items-per-page-options': [30, 40, {text:'All', value:-1}] }"
            >
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-for="item in items" :key="item.id">
              <td >{{ item.id }}</td>
              <td >{{ item.name }}</td>
              <td >{{ item.description }}</td>
              <td >{{ item.amount }}</td>
              <td >{{ item.date }}</td>
              <td class="justify-center layout px-0" v-if="can('invoicing')">
                <v-btn icon class="mx-0" @click="viewItem(item)">
                  <v-icon color="primary">visibility</v-icon>
                </v-btn>
                <v-btn icon class="mx-0" @click="editItem(item)">
                  <v-icon color="primary">edit</v-icon>
                </v-btn>
                <v-btn icon class="mx-0" @click="deleteItem(item)">
                  <v-icon color="primary">delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
            <template slot="pageText" slot-scope="{ pageStart, pageStop }">
              From {{ pageStart }} to {{ pageStop }}
            </template>
          </v-data-table>
        </v-card>


      </div>
    </m-layout>
</template>

<script>
  import moment from 'moment';
  import InsertsMixin from '@/mixins/inserts'
  import InsertsForm from '@/components/inserts/form.vue'
  import InsertsEdit from '@/components/inserts/edit.vue'
  import CSVMixin from '@/mixins/CSVMixin'
  import AuthMixin from '@/mixins/auth'

  export default {
    mixins: [AuthMixin, CSVMixin, InsertsMixin],
    components: {
      'm-inserts-edit': InsertsEdit,
      'm-inserts-form': InsertsForm
    },
    data () {
      return {
        form: {},
        dateFormatted: null,
        dialog: false,
        dialog_edit: false,
        dialog_view: false,
        search: '',
        pagination: {},
        selectedItem: {},
        headers: [
          {
            text: 'ID',
            align: 'left',
            sortable: false,
            value: 'id'
          },
          { text: 'Name', value: 'name' },
          { text: 'Description', value: 'description' },
          { text: 'Amount', value: 'amount' },
          { text: 'Date', value: 'date' },
          { text: 'Action', value: 'action' }
        ],
        items: [],
        imageUrl: ''
      }
    },
    methods: {
      formatDate (date) {
        if (!date) {
          return null
        }
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      onSave (data) {
        this.sendForm(data);
        this.dialog = false;
      },
      onClose () {
        this.dialog = false;
        this.dialog_view = false;
        this.dialog_edit = false;
        this.reset();
        console.log('close');
      },
      reset () {
        this.form = {};
      },
      onRefresh () {
        this.getData();
      },

      onUpdate (data) {
        this.updateForm(data);
        this.onClose();
      },
      sendForm (data) {
        // var app = this;
        this.$http
        .post('api/inserts', data)
        .then(response => {
          console.log('response data', response.data);
          // app.items = response.data;
          this.reset();
          this.getData();
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      updateForm (data) {
        // var app = this;
        var id = this.selectedItem.id;
        console.log('updateForm', data);
        this.$http
        .put('api/inserts/' + id, data)
        .then(response => {
          console.log('response data', response.data);
          // this.reset();
          this.getData();
          // app.items = response.data;
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      viewItem (item) {
        this.reset();
        this.selectedItem = this.items.find(i => i === item);
        this.imageUrl = this.selectedItem.imageUrl;
        if (!this.imageUrl) {
          this.dialog_view = true;
        } else {
          window.open(this.imageUrl, '_blank');
        }

        console.log('edit', this.selectedItem);
      },
      editItem (item) {
        this.reset();
        this.selectedItem = this.items.find(i => i === item);
        this.imageUrl = this.selectedItem.imageUrl;
        this.dialog_edit = true;
      },
      deleteItem (item) {
        this.$http
        .delete('api/inserts/' + item.id)
        .then(response => {
          this.deleteExpense(item.itemKey).then(this.getData());
          console.log('insert deleted', response.data);
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      getData () {
        var app = this;
        this.$http
        .get('api/inserts')
        .then(response => {
          console.log('data', response.data);
          app.items = response.data;
          this.createCSV(app.items);
          app.items.map(function (d) {
            d.date = app.$options.filters.date(d.date)
          });
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      }
    },
    created () {
      this.getData();
    },
    filters: {
      date: function (date) {
        return moment(date).format('DD/MM/YYYY');
      },
      formatIndex (v, obj) {
        return obj[v];
      },
      toTime (sec) {
        var time;
        if (sec > 3600) {
          time = new Date(sec * 1000).toISOString().substr(11, 5) + ' h'
        } else {
          time = new Date(sec * 1000).toISOString().substr(14, 2) + ' mins'
        }
        return time;
      }
    }
  }
</script>

<style lang="scss">
.error {
  text-transform: none;
  color: grey;

  &-item {
    color:rgba(248, 1, 1, 1) !important;
  }
}
</style>









